const debounce = (func: (...args: unknown[]) => void, wait: number) => {
    let timeout: number | undefined;
    return function executedFunction(...args: unknown[]) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);  
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
};

type Result = {
    title: string;
    url: string;
}

export class Search {
    input: HTMLInputElement;
    suggestionBox: HTMLElement;

    constructor() {
        this.input = document.querySelector<HTMLInputElement>('#nav-search')!;
        this.suggestionBox = document.querySelector<HTMLElement>('#search-list')!;

        this.init();
    }

    init() {
        const debouncedFetch = debounce(this.fetchSuggestions.bind(this), 300);
        this.input.addEventListener('input', () => {
            const value = this.input.value;
            if (value.length > 2) {
                debouncedFetch();
            } else {
                this.suggestionBox.innerHTML = '';
            }
        });
    }

    async fetchSuggestions() {
        const value = this.input.value;
        const uri = new URL(`${wpApiSettings.root}rr/v2/search`);
        uri.searchParams.set('term', value);

        const response = await fetch(uri.toString());
        const data = await response.json() as Result[];

        this.printSuggestions(data);
    }

    printSuggestions(data: Result[]) {
        if(data.length > 0) {
            this.suggestionBox.parentElement?.classList.add('active');
        } else {
            this.suggestionBox.parentElement?.classList.remove('active');
        }
        this.suggestionBox.innerHTML = '';
        data.forEach(item => {
            const li = document.createElement('li');
            const a = document.createElement('a');
            a.href = item.url;
            a.textContent = item.title;
            li.appendChild(a);
            this.suggestionBox.appendChild(li);
        });
    }
}
